// Úkoly: typované funkce nad api() podle smlouvy v packages/shared/src/promises.ts.
import type {
  ApiList,
  CreateTaskInput,
  ListTasksQuery,
  TaskItem,
  UpdateTaskInput,
} from '@wac-buddy/shared'
import { api } from './client'
import { buildQuery } from './query'

export type TaskFilter = ListTasksQuery['filter']

export interface ListTasksParams {
  filter?: TaskFilter
  assigneeId?: string
  jobId?: string
  cursor?: string | null
  limit?: number
}

export function listTasks(params: ListTasksParams = {}): Promise<ApiList<TaskItem>> {
  return api(
    `/tasks${buildQuery({
      filter: params.filter,
      assigneeId: params.assigneeId,
      jobId: params.jobId,
      cursor: params.cursor,
      limit: params.limit,
    })}`,
  )
}

export function createTask(input: CreateTaskInput): Promise<TaskItem> {
  return api('/tasks', { method: 'POST', body: JSON.stringify(input) })
}

export function updateTask(id: string, input: UpdateTaskInput): Promise<TaskItem> {
  return api(`/tasks/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteTask(id: string): Promise<void> {
  return api(`/tasks/${encodeURIComponent(id)}`, { method: 'DELETE' })
}
